/*
* LayoutManager.js
* Created on 14-3-2017
* @author reinier feijen for &ranj
*/

import ScreenNavigator from "../ui/ScreenNavigator";
import LayoutEvent from "./LayoutEvent";
import LayoutItem from "./LayoutItem";

export default class LayoutManager {
    /**
     * 
     * @param {createjs.Stage} stage 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ScreenNavigator} screenNavigator 
     */
    constructor(stage, dispatcher, screenNavigator) {
        this.stage = stage;
        this._dispatcher = dispatcher;
        this._screenNavigator = screenNavigator;

        this._viewport = new createjs.Rectangle();
        this._viewportOriginal = new createjs.Rectangle();

        this._layoutItems = {};
    }

    destroy() {
        for (var s in this._layoutItems) {
            this._layoutItems[s].destroy();
        }
        this._layoutItems = null;
        this.root = null;
    }

    /**
     * Get viewport, optionally in coordpsace of specified displayobject.
     * @param {createjs.DisplayObject} displayObject Optional
     * @returns {createjs.Rectangle} Rectangle, optionally in coordinate space of given displayObject
     */
    getViewport(displayObject) {
        var vp = this._viewport.clone();
        if (displayObject) {
            var tl = this.stage.localToLocal(vp.x, vp.y, displayObject);
            var br = this.stage.localToLocal(vp.x + vp.width, vp.y + vp.height, displayObject);
            vp.setValues(Math.min(tl.x, br.x), Math.min(tl.y, br.y), Math.abs(br.x - tl.x), Math.abs(br.y - tl.y));
        }
        return vp;
    }

    /**
     * All values in stage coord space
     * @param {Number} x - x of viewport
     * @param {Number} y - y of viewport
     * @param {Number} w - width of viewport
     * @param {Number} h - height of viewport
     * @param {Number} xo - x of original/design viewport
     * @param {Number} yo - y of original/design viewport
     * @param {Number} wo - width of original/design viewport
     * @param {Number} ho - height of original/design viewport
     */
    setViewport(x, y, w, h, xo, yo, wo, ho) {
        console.debug("LayoutManager.setViewport ", w, h, wo, ho);
        this._viewport.setValues(x, y, w, h);
        this._viewportOriginal.setValues(xo, yo, wo, ho);
        this._screenNavigator.setScreenDimensions(w, h);

        for (const s in this._layoutItems) {
            this._layoutItems[s].update(this.stage, this._viewport, this._viewportOriginal);
        }

        this._dispatcher.dispatch(LayoutEvent.CHANGED);
    }

    registerObject(target, anchor, fillArea) {
        const item = new LayoutItem(target, anchor, fillArea);
        this._layoutItems[target.id] = item;
        //apply last update to item
        if (this._viewport.width) {
            item.update(this.stage, this._viewport, this._viewportOriginal);
        }
    }

    deregisterObject(target, resetPosition = false) {
        /** @type {LayoutItem} */
        var item = this._layoutItems[target.id];
        if (item) {
            item.destroy(resetPosition);
            delete this._layoutItems[target.id];
        }
    }

}







